/* src/app/content/content.component.scss */
a:hover {
  cursor: pointer;
}
a:not([href]):not([tabeindex]) {
  text-decoration: underline;
}
.filter-row {
  display: flex;
  align-items: center;
}
.filter-row input[type=text] {
  line-height: 2rem;
  width: 150px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 14px;
  margin: 0;
}
.filter-row select {
  line-height: 2rem;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 14px;
  margin: 0;
}
.filter-row .toolbar {
  margin-left: 20px;
  display: flex;
  align-items: center;
}
.filter-row .toolbar a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 2rem;
  padding: 0 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;
  color: #333;
  text-decoration: none;
  box-sizing: border-box;
  margin-right: 10px;
  cursor: pointer;
  font-size: 14px;
}
.filter-row .toolbar a:hover {
  background-color: #eee;
}
.filter-row .toolbar-item {
  margin-left: 20px;
  display: flex;
  align-items: center;
  height: 40px;
}
.filter-row .toolbar-item label {
  margin-bottom: 0;
  margin-right: 10px;
}
.mat-mdc-cell {
  text-align: left;
}
.mat-column-active {
  flex: 0 0 75px !important;
  justify-content: center;
}
.mat-column-active ::ng-deep label {
  margin-bottom: 0px !important;
}
.mat-column-id {
  max-width: 70px;
}
.mat-column-version {
  max-width: 75px;
}
.mat-column-type {
  max-width: 100px;
}
.mat-column-name {
  min-width: 550px;
}
.mat-column-code_count {
  max-width: 60px;
}
.mat-column-ts {
  max-width: 200px;
}
.mat-column-vimeoId {
  max-width: 100px;
}
.mat-column-publish {
  min-width: 115px;
}
.mat-mdc-row:hover {
  background-color: darkgray;
  color: black;
}
.mat-mdc-row:hover .menu {
  display: inline-flex;
}
.mat-mdc-row .menu {
  padding: 5px;
  border-radius: 5px;
  gap: 15px;
  display: none;
}
.mat-mdc-row .menu a {
  border: 1px solid #6e6666;
  background: #ccc;
  border-radius: 10px;
  padding: 3px;
  min-width: 35px;
  text-align: center;
}
.mat-mdc-row .menu a:hover {
  cursor: pointer;
  background-color: white;
  border: white;
}
.mat-mdc-row.active-row:hover {
  color: white;
  background-color: #7e6aa8;
}
.tip {
  text-align: left;
  background: #fffec8;
  color: black;
  padding: 20px;
  border-radius: 5px;
  position: relative;
}
.tip a {
  color: black;
}
h2 {
  text-align: right;
  padding-right: 20px;
  margin-top: -20px;
}
.mat-mdc-row {
  position: relative !important;
}
.mat-mdc-cell {
  align-self: center;
}
.mat-column-publish {
  flex: 0 0 110px !important;
  justify-content: flex-end;
}
.mat-column-publish .publish-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  padding: 3px 10px;
  border: 1px solid #6dcc09;
  border-radius: 4px;
  color: #6dcc09;
  background: transparent;
  cursor: pointer;
  transition:
    background 0.15s,
    color 0.15s,
    border-color 0.15s;
}
.mat-column-publish .publish-btn:hover:not(:disabled) {
  background: #6dcc09;
  color: #fff;
}
.mat-column-publish .publish-btn:disabled {
  cursor: default;
  opacity: 1;
  border: 1px solid #6dcc09 !important;
}
.mat-column-publish .publish-btn.state-success {
  border: 1px solid #6dcc09 !important;
  color: #6dcc09;
}
.mat-column-publish .publish-btn.state-error {
  border-color: #c44949;
  color: #c44949;
}
.mat-column-publish .publish-btn .publish-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  line-height: 14px;
}
.mat-column-publish .publish-btn .publish-spinner {
  width: 12px;
  height: 12px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: publish-spin 0.6s linear infinite;
  flex-shrink: 0;
}
@keyframes publish-spin {
  to {
    transform: rotate(360deg);
  }
}
.mat-column-duration {
  max-width: 100px;
  display: flex !important;
  align-items: center;
  gap: 4px;
}
.duration-refresh-btn {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  cursor: pointer;
  color: #757575;
  text-decoration: none !important;
}
.duration-refresh-btn .mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  line-height: 15px;
}
.duration-refresh-btn:hover {
  background-color: rgba(0, 0, 0, 0.04);
  color: #333;
}
.duration-refresh-btn.loading {
  pointer-events: none;
}
.duration-refresh-btn.loading .mat-icon {
  animation: publish-spin 0.8s linear infinite;
}
.duration-refresh-btn.error {
  color: #c44949;
}
.mat-column-actions {
  flex: 0 0 60px !important;
  display: flex !important;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px !important;
  overflow: visible !important;
}
.action-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu-trigger {
  opacity: 0;
  transition: opacity 0.2s;
  background: transparent !important;
  border: none !important;
  outline: none !important;
  padding: 0 !important;
  min-width: unset !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.menu-trigger .mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #757575;
}
.menu-trigger:hover,
.menu-trigger.active {
  background-color: rgba(0, 0, 0, 0.04) !important;
  opacity: 1 !important;
}
.menu-trigger {
  text-decoration: none !important;
}
.mat-mdc-row:hover .menu-trigger {
  opacity: 1;
}
.row-toolbar {
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  margin-right: 5px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  padding: 5px 0;
  min-width: 140px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-50%) scale(0.95);
  transition:
    opacity 0.25s ease,
    transform 0.25s ease,
    visibility 0s linear 0.25s;
}
.row-toolbar.visible {
  opacity: 1;
  visibility: visible;
  transform: translateY(-50%) scale(1);
  transition-delay: 0s;
}
.row-toolbar.visible .action-btn {
  opacity: 1;
  transition: opacity 0.25s ease;
}
.action-btn {
  display: block;
  padding: 8px 16px;
  background-color: transparent;
  border: none;
  font-size: 13px;
  color: #333 !important;
  text-decoration: none !important;
  cursor: pointer;
  white-space: nowrap;
  text-align: left;
  line-height: normal;
  opacity: 0;
  transition: opacity 0.1s ease;
}
.action-btn:hover {
  background-color: #f5f5f5;
  color: black !important;
}
.action-btn {
  margin: 0;
  border-bottom: none;
  border-radius: 0;
}
.title {
  margin: 20px 20px 0px 20px;
  display: flex;
  justify-content: space-between;
  font-size: 1.5rem;
}
/*# sourceMappingURL=content.component.css.map */
